import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";


function EditVideoLanguage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [editUser, setEditUser] = useState({
    name: "",
    language_image: "",
  });
  const [editname, setEditname] = useState({
    name: "",
  });
  const access_token = localStorage.getItem("access_token");

  const [loading, setLoading] = useState(true);

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/language/edit/${id}`,
        { headers: headers }
      );
      const resData = await reqData?.json();
      var res = resData?.Languages;
      var results = resData?.users;
      setEditUser(res);
      setEditname(res);
      setLoading(false);
      // console.log("result", res);
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "all-language" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
    getUser();
  }, [id]);

  const fileInputRef1 = useRef(null);

  const [selectedFile1, setSelectedFile1] = useState(null);

  const handleFileChange = (event, fileInputRef, setSelectedFile) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagename("");
    setIsValidationHiddenname(true);

    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };

  const [validationMessagename, setValidationMessagename] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);

  const nameInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  // const handleUpdate = async (e) => {
  //   let focusInputRef = null;

  //   if (editUser?.name === "") {
  //     setValidationMessagename("Name cannot be empty.");
  //     setIsValidationHiddenname(false);
  //     focusInputRef = nameInputRef;
  //   }

  //   if (focusInputRef) {
  //     focusInputRef.current.focus();
  //     return;
  //   }

  //   e.preventDefault();

  //   const editInputvalue = {
  //     name: editUser?.name,
  //   };

  //   let firstApiStatus = false;
  //   let secondApiStatus = false;
  //   let resultapi = null;
  //   let resjson = null;
  //   setProcessing(true);
  //   setShowOverlay(true);

  //   try {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_Baseurl}/admin/language/update/${id}`,
  //       {
  //         method: "POST",
  //         headers: headers,
  //         body: JSON.stringify(editInputvalue),
  //       }
  //     );

  //     resjson = await res.json();

  //     if (resjson.status === true) {
  //       firstApiStatus = true;

  //       resultapi = resjson;

  //       var result = resjson.artist_id;

  //       const formData = new FormData();
  //       formData.append("language_id", id);

  //       if (selectedFile1) {
  //         formData.append("image",selectedFile1);
  //       }

  //       await axios.post(
  //         `${process.env.REACT_APP_Baseurl}/admin/language/image-update`,
  //         formData,
  //         { headers: headers }
  //       );
  //       secondApiStatus = true;
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }

  //   if (firstApiStatus && secondApiStatus) {
  //     setValidationMessagename("");
  //     props?.setApiresponsealert(resultapi);
  //     props?.setShowalert(true);
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 1500);
  //   } else {
  //     if (resjson.status === false) {
  //       var resultError = resjson;
  //       props?.setApiresponsealert(resultError);
  //       props?.setShowalert(true);
  //       setIsValidationHiddenname(false);
  //       setProcessing(false);
  //       setShowOverlay(false);
  //     }
  //   }
  // };


  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editUser?.name === "") {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      name: editUser?.name,
    };

    let firstApiStatus = false;
    let secondApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      // First API Call
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/language/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;
        resultapi = resjson;

        // Prepare FormData for Image Upload
        const formData = new FormData();
        formData.append("language_id", id);

        if (selectedFile1) {
          // Case 1: If a new image is selected, send it
          formData.append("image", selectedFile1);
        } else if (editUser?.language_image) {
          // Case 2: If no new image is selected, send existing image in binary format
          const response = await fetch(editUser.language_image);
          const blob = await response.blob();
          formData.append("image", blob, "language_image.jpg"); // Ensure a filename is provided
        }

        // Make the Second API Call if there's an image to upload
        if (selectedFile1 || editUser?.language_image) {
          const imageRes = await axios.post(
            `${process.env.REACT_APP_Baseurl}/admin/language/image-update`,
            formData,
            { headers: headers }
          );

          if (imageRes.data.status === true) {
            secondApiStatus = true;

            // Update state with new image URL if available
            setEditUser((prev) => ({
              ...prev,
              language_image: imageRes.data.image_url || prev.language_image,
            }));
          }
        } else {
          secondApiStatus = true; // No image update needed, mark as success
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus && secondApiStatus) {
      setValidationMessagename("");
      props?.setApiresponsealert(resultapi);
      props?.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      if (resjson?.status === false) {
        props?.setApiresponsealert(resjson);
        props?.setShowalert(true);
        setIsValidationHiddenname(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      <div className=" m-0 p-0">
        <div className="">
          <section className="container-fluid">
            <div className="col-lg-12 row py-3">
              <div className="col-6 col-sm-6 col-lg-6">
                <h3>Edit {`${labelDisplay?.[0]?.sub_title}`}</h3>
              </div>
              <div className="col-6 col-sm-6 col-lg-6">
                <div className="text-end">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    {`${labelDisplay?.[6]?.sub_title}`}
                  </button>
                </div>
              </div>
            </div>
            <div>
              {showOverlay && (
                <div className="overlay-container">
                  <span className="overlay-icon">
                    {" "}
                    <Response_Loading_processing></Response_Loading_processing>
                    Processing ...
                  </span>
                </div>
              )}
            </div>

            <div className="row col-lg-12 ">
              <div className=" col-sm-6 col-md-6 col-lg-6 ">
                <div className="card p-3">
                  <h5>{editname?.name}</h5>
                  <hr></hr>
                  <div className=" text-start">
                    <label className="m-0">
                      {`${labelDisplay?.[2]?.title}`}<span className="mandatory">*</span>
                    </label>
                    <div className="mt-2">
                      <input
                        type="text"
                        className="rs-input form-control-lg"
                        // id="username"
                        name="name"
                        placeholder="Enter Name"
                        onChange={handleInput}
                        value={editUser?.name}
                        ref={nameInputRef}
                      />
                    </div>
                    <span className="errorred">
                      {!isValidationHiddenname && (
                        <p>{validationMessagename}</p>
                      )}
                    </span>
                  </div>
                </div>

                {/* <div className="text-start mb-3">
                  <button onClick={handleUpdate} className="btn btn-primary">
                    Update Equipment
                  </button>
                </div> */}
              </div>

              {/* Second Part of Section  */}

              <div className=" col-sm-6 col-md-6 col-lg-6">
                <div className="card p-3">
                  <h5> {`${labelDisplay?.[3]?.title}`}</h5>
                  <hr></hr>

                  {/* <div className=" text-start mt-2" hidden>
                    <label className="m-0">Image</label>

                    <div>
                      {editUser?.language_image ? (
                        <img
                          src={editUser?.language_image}
                          alt="Image"
                          className="thumbnails-images"
                        />
                      ) : (
                        <Response_Loading_processing></Response_Loading_processing>
                      )}
                    </div>

                    <div className="mt-2">
                      <div className="col-lg-12 row">
                        <div className=" col-sm-6 col-lg-6">
                          <div
                            className="imagedrop"
                            onClick={() => fileInputRef1.current.click()}
                          >
                            <input
                              type="file"
                              ref={fileInputRef1}
                              onChange={(event) =>
                                handleFileChange(
                                  event,
                                  fileInputRef1,
                                  setSelectedFile1
                                )
                              }
                              accept="image/*"
                              style={{ display: "none" }}
                            />
                            <button>
                              <CameraRetroIcon />
                            </button>
                          </div>
                        </div>
                        <div className=" col-sm-6 col-lg-6">
                          <div>
                            {selectedFile1 && (
                              <div className="imagedropcopy text-end">
                                <div className="col-lg-12 row p-0 m-0">
                                  <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                    <img
                                      src={URL?.createObjectURL(selectedFile1)}
                                      alt="Uploaded"
                                      className="thumbnails-upload-images"
                                    />
                                  </div>
                                  <div
                                    className="col-sm-2 col-lg-2 p-0 m-0"
                                    style={{ alignSelf: "center" }}
                                  >
                                    <button
                                      onClick={() => handleDelete(1)}
                                      type="button"
                                      className="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className=" text-start mt-2">
                    <label>{`${labelDisplay?.[4]?.title}`}</label>
                    {/* Image Validation */}
                    {/* <p> 
                      <small>
                        {`${labelDisplay?.[4]?.sub_title}`}
                      </small>
                    </p> */}

                    <div>
                      {editUser?.language_image ? (
                        <img
                          src={editUser?.language_image}
                          alt="Image"
                          className="thumbnails-images"
                        />
                      ) : (
                        <Response_Loading_processing></Response_Loading_processing>
                      )}
                    </div>

                    <div className="mt-2">
                      <div className="col-lg-12 row">
                        <div className=" col-sm-6 col-lg-6">
                          <div
                            className="imagedrop"
                            onClick={() => fileInputRef1.current.click()}
                          >
                            <input
                              type="file"
                              ref={fileInputRef1}
                              onChange={(event) =>
                                handleFileChange(
                                  event,
                                  fileInputRef1,
                                  setSelectedFile1
                                )
                              }
                              accept="image/*"
                              style={{ display: "none" }}
                            />
                            <label>
                              <CameraRetroIcon />
                            </label>
                          </div>
                        </div>
                        <div className=" col-sm-6 col-lg-6">
                          <div>
                            {selectedFile1 && (
                              <div className="imagedropcopy text-end">
                                <div className="col-lg-12 row p-0 m-0">
                                  <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                    <img
                                      src={URL.createObjectURL(selectedFile1)}
                                      alt="Uploaded"
                                      className="thumbnails-upload-images"
                                    />
                                  </div>
                                  <div
                                    className="col-sm-2 col-lg-2 p-0 m-0"
                                    style={{ alignSelf: "center" }}
                                  >
                                    <button
                                      onClick={() => handleDelete(1)}
                                      type="button"
                                      className="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
export default EditVideoLanguage;
